import { useAuth0 } from '@auth0/auth0-react'

const useJwtDecode = () => {
  const { getAccessTokenSilently } = useAuth0()

  const decodeToken = async () => {
    const res = await getAccessTokenSilently({
      scope: "openid offline_access",
      grant: "refresh_token",
      detailedResponse: true
    })
  
    const access_token = res.access_token

    let base64Url = access_token.split('.')[1]
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))

    return JSON.parse(jsonPayload)
  }

  return { decodeToken }
}

export default useJwtDecode
